import React from "react";

const LogoBe = ({ hauteur, color }) => {
  return (
    <svg height={hauteur ? hauteur : "40px"} viewBox="0 0 51 39">
      <g
        id="Logo-favicon"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Artboard"
          transform="translate(-372.000000, -317.000000)"
          fill={color ? color : "#205A71"}
          fillRule="nonzero"
        >
          <path
            d="M391.675,355.85 C394.241667,355.85 396.35,355.041667 398,353.425 C399.65,351.808333 400.833333,349.883333 401.55,347.65 C402.266667,345.416667 402.625,343.35 402.625,341.45 C402.625,339.416667 402.141667,337.658333 401.175,336.175 C400.208333,334.691667 398.725,333.766667 396.725,333.4 C398.325,332.5 399.558333,331.333333 400.425,329.9 C401.291667,328.466667 401.725,326.983333 401.725,325.45 C401.725,324.016667 401.333333,322.7 400.55,321.5 C399.766667,320.3 398.575,319.333333 396.975,318.6 C395.375,317.866667 393.408333,317.5 391.075,317.5 C387.975,317.5 385.025,318.125 382.225,319.375 C379.425,320.625 377.175,322.266667 375.475,324.3 C373.775,326.333333 372.925,328.483333 372.925,330.75 C372.925,332.383333 373.375,333.558333 374.275,334.275 C375.175,334.991667 376.508333,335.35 378.275,335.35 C378.275,335.283333 378.158333,335.008333 377.925,334.525 C377.691667,334.041667 377.575,333.183333 377.575,331.95 C377.575,329.35 378.183333,327.133333 379.4,325.3 C380.616667,323.466667 382.191667,322.091667 384.125,321.175 C386.058333,320.258333 388.041667,319.8 390.075,319.8 C392.308333,319.8 393.966667,320.316667 395.05,321.35 C396.133333,322.383333 396.675,323.666667 396.675,325.2 C396.675,326.466667 396.341667,327.725 395.675,328.975 C395.008333,330.225 394.125,331.258333 393.025,332.075 C391.925,332.891667 390.741667,333.3 389.475,333.3 L389.175,333.3 L391.525,322.2 L384.125,323.2 L377.325,355 L384.525,355 L388.625,335.85 C389.258333,335.75 390.025,335.7 390.925,335.7 C394.091667,335.7 395.675,337.816667 395.675,342.05 C395.675,344.316667 395.266667,346.383333 394.45,348.25 C393.633333,350.116667 392.391667,351.05 390.725,351.05 C390.125,351.05 389.566667,350.916667 389.05,350.65 C388.533333,350.383333 387.975,349.916667 387.375,349.25 C386.941667,350.316667 386.725,351.283333 386.725,352.15 C386.725,353.516667 387.216667,354.475 388.2,355.025 C389.183333,355.575 390.341667,355.85 391.675,355.85 Z M411.425,355.3 C416.291667,355.3 419.175,352.833333 420.075,347.9 C419.208333,348.666667 418.241667,349.3 417.175,349.8 C416.108333,350.3 415.108333,350.55 414.175,350.55 C412.108333,350.55 411.075,349.166667 411.075,346.4 C411.075,346.133333 411.108333,345.633333 411.175,344.9 C413.175,344.766667 415.058333,344.225 416.825,343.275 C418.591667,342.325 420.008333,341.066667 421.075,339.5 C422.141667,337.933333 422.675,336.216667 422.675,334.35 C422.675,331.15 420.841667,329.55 417.175,329.55 C414.041667,329.55 411.458333,330.558333 409.425,332.575 C407.391667,334.591667 405.925,336.983333 405.025,339.75 C404.125,342.516667 403.675,345.05 403.675,347.35 C403.675,350.083333 404.358333,352.091667 405.725,353.375 C407.091667,354.658333 408.991667,355.3 411.425,355.3 Z M411.525,342.5 C412.091667,339.866667 412.95,337.491667 414.1,335.375 C415.25,333.258333 416.408333,332.2 417.575,332.2 C418.408333,332.2 418.825,332.883333 418.825,334.25 C418.825,335.616667 418.483333,336.925 417.8,338.175 C417.116667,339.425 416.216667,340.45 415.1,341.25 C413.983333,342.05 412.791667,342.466667 411.525,342.5 Z"
            id="Be"
          ></path>
        </g>
      </g>
    </svg>
  );
};

const NomSinobi = ({ hauteur, color, style }) => {
  return (
    <svg height={hauteur ? hauteur : "40px"} viewBox="0 0 123 39" style={style}>
      <g
        id="Design"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
        fontFamily="Lobster-Regular, Lobster"
        fontSize="50"
        fontWeight="normal"
      >
        <g
          id="Qi"
          transform="translate(-63.000000, -12.000000)"
          fill={color ? color : "#FFFFFF"}
        >
          <text id="Sinobi">
            <tspan x="62" y="50">
              Sinobi
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
};

const LogoSinobi = ({ hauteur, color }) => {
  return (
    <svg height={hauteur ? hauteur : "30px"} viewBox="0 0 41 41">
      <g
        id="Design"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Qi"
          transform="translate(-15.000000, -13.000000)"
          fill={color ? color : "#FFFFFF"}
          fillRule="nonzero"
        >
          <g id="Group-10" transform="translate(15.000000, 13.000000)">
            <path
              d="M20.5,0 C31.8218374,0 41,9.17816263 41,20.5 C41,31.8218374 31.8218374,41 20.5,41 C9.17816263,41 0,31.8218374 0,20.5 C0,9.17816263 9.17816263,0 20.5,0 Z M20.5,2 C10.2827321,2 2,10.2827321 2,20.5 C2,30.7172679 10.2827321,39 20.5,39 C30.7172679,39 39,30.7172679 39,20.5 C39,10.2827321 30.7172679,2 20.5,2 Z M25,27 L25.0003204,36.3788119 C23.56973,36.7834662 22.0601521,37 20.5,37 C18.9402113,37 17.4309732,36.7835671 16.0006793,36.3790947 L16,27 L25,27 Z M14,27 L13.9998654,35.670295 C10.1141237,34.0031553 6.99752235,30.8867442 5.33013405,27.0011344 L14,27 Z M27.0011344,35.669866 L27,27 L35.669866,27.0011344 C34.0026207,30.8864109 30.8864109,34.0026207 27.0011344,35.669866 Z M14,16 L14,25 L4.62118809,25.0003204 C4.21653381,23.56973 4,22.0601521 4,20.5 C4,18.9402113 4.21643295,17.4309732 4.62090535,16.0006793 L14,16 Z M37,20.5 C37,22.0601521 36.7834662,23.56973 36.3788119,25.0003204 L27,25 L27,16 L36.3790947,16.0006793 C36.7835671,17.4309732 37,18.9402113 37,20.5 Z M13.9998654,5.32970504 L14,14 L5.32970504,13.9998654 C6.99698773,10.1137904 10.1137904,6.99698773 13.9998654,5.32970504 Z M20.5,4 C22.0601521,4 23.56973,4.21653381 25.0003204,4.62118809 L25,14 L16,14 L16.0006793,4.62090535 C17.4309732,4.21643295 18.9402113,4 20.5,4 Z M35.670295,13.9998654 L27,14 L27.0011344,5.33013405 C30.8867442,6.99752235 34.0031553,10.1141237 35.670295,13.9998654 Z"
              id="Combined-Shape"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default function Logo({ couleur, taille }) {
  //NES gestion de la couleur
  let couleurLogo = "white";
  switch (couleur) {
    case "bleu":
      couleurLogo = "#213945";
      break;
    case "blanc":
      couleurLogo = "white";
      break;
    default:
      couleurLogo = "white";
      break;
  }

  //NES gestion de la taille
  let tailleLogo = "60px";
  let tailleTexte = "50px";
  switch (taille) {
    case "S":
      tailleLogo = "20px";
      tailleTexte = "15px";

      break;
    case "L":
      tailleLogo = "80px";
      tailleTexte = "60px";

      break;
    case "M":
      tailleLogo = "40px";
      tailleTexte = "30px";

      break;
    default:
      tailleLogo = "60px";
      tailleTexte = "50px";

      break;
  }

  if (process.env.REACT_APP_NOM === "BE") {
    return (
      <div>
        <LogoBe hauteur={tailleLogo} color={couleurLogo} />
      </div>
    );
  } else {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <LogoSinobi hauteur={tailleLogo} color={couleurLogo} />
        <NomSinobi
          style={{ marginLeft: "10px" }}
          hauteur={tailleTexte}
          color={couleurLogo}
        />
      </div>
    );
  }
}
